import styled from "styled-components";
import { colors } from "../../../styles/style";

export const MilestoneCard: React.FC<MilestoneCardProps> = ({
  $icon_src,
  title,
  $min_width,
  $max_width,
  width,
  onClick,
  $bgColor,
  isNew,
  isLocked,
}) => {
  return (
    <Container
      $icon_src={$icon_src}
      title={title}
      $min_width={$min_width}
      $max_width={$max_width}
      width={width}
      onClick={onClick}
      $bgColor={$bgColor}
    >
      {isNew && !isLocked && <NewBadge>New</NewBadge>}
      {isLocked && (
        <LockBadge aria-label="Part of Pro">
          <LockBody />
          <LockShackle />
        </LockBadge>
      )}
      <CardLayout>
        <CardIcon src={$icon_src} alt="Milestone Icon" $dimmed={isLocked} />
        <MilestoneTitle $dimmed={isLocked}>{title}</MilestoneTitle>
      </CardLayout>
    </Container>
  );
};
interface MilestoneCardProps {
  $icon_src: string;
  title: string;
  $min_width?: string;
  $max_width?: string;
  width?: string;
  onClick?: (() => void) | undefined;
  $bgColor?: string;
  isNew?: boolean;
  isLocked?: boolean;
}

const Container = styled.div<MilestoneCardProps>`
  position: relative;
  border-radius: 20px;
  border: 1px solid ${colors.borderWhite};
  background-color: ${(props) => props.$bgColor || colors.bgWhite};
  min-width: ${(props) => props.$min_width || "150px"};
  max-width: ${(props) => props.$max_width || "100%"};
  width: ${(props) => props.width || "auto"};
  height: 92px;
  padding: 6px;
  flex-shrink: 0;
  border-radius: 20px;
`;

const NewBadge = styled.span`
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 2px 8px;
  border-radius: 100px;
  background-color: ${colors.warmthPink};
  color: ${colors.white};
  font-size: 12px;
  font-weight: 450;
`;

/* Same corner as the "New" badge, and the two never show together: a locked
   card says "locked" first, because that is what explains the behaviour. */
const LockBadge = styled.span`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 22px;
  height: 22px;
  border-radius: 100px;
  background-color: ${colors.softPink};
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 5px;
`;

const LockBody = styled.span`
  width: 10px;
  height: 7px;
  border-radius: 2px;
  background-color: ${colors.warmthBrown};
`;

const LockShackle = styled.span`
  position: absolute;
  top: 4px;
  width: 6px;
  height: 5px;
  border: 1.5px solid ${colors.warmthBrown};
  border-bottom: none;
  border-radius: 4px 4px 0 0;
`;

const CardIcon = styled.img<{ $dimmed?: boolean }>`
  opacity: ${(props) => (props.$dimmed ? 0.45 : 1)};
`;

const CardLayout = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 40px 0 0 10px;
  width: fit-content;
  height: 32px;
  @media (max-width: 360px) {
    margin: 40px 0 0 8px; /* Adjust the margin for smaller screens */
  }
`;

const MilestoneTitle = styled.span<{ $dimmed?: boolean }>`
  color: ${(props) => (props.$dimmed ? colors.warmthPink : colors.darkBrown)};
  font-size: 16px;
  font-style: normal;
  font-weight: 450;
  line-height: normal;
`;
